module.exports = __webpack_public_path__ + "static/squares-bottom-c385a91a613cd653b20a4ae74a6ef125.png";